/** Shared layout dimensions for app navigation drawer */
/** v-app-bar height (AppHeader); keep in sync with drawer offsets via --app-header-height. */
export const APP_HEADER_HEIGHT = 64;
export const NAVIGATION_DRAWER_WIDTH = 260;
export const NAVIGATION_DRAWER_MINI_WIDTH = 56;
